import { TemplateResult, html } from "lit-html"

import { DialogParts, SYSBaseDialog } from "./sysdialogbase"
import { DialogClose, DialogHolderParams } from "./dialogapi"
import { SYSBaseElement, SYSDialog } from "../../index"
import { DialogGetParts } from "./sysdialogholder"
import { SYSDialogBase } from "./sysdialog2base"

export const DialogGet = async (
  dialogComp: SYSBaseElement,
  dialogParts: DialogGetParts
): Promise<TemplateResult> => {
  if (!dialogParts.instance) {
    dialogParts.instance = dialogComp.dialogInstance
  }
  const defaultKeyHandler = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      e.stopPropagation()
      e.preventDefault()
      if (dialogParts.closeOnDismiss) {
        DialogClose(dialogComp.dialog, { instance: dialogParts.instance })
      } else if (dialogParts.dismissedCallbackFn) {
        dialogParts.dismissedCallbackFn()
      }
    }
  }

  // now put together the template

  let handleTopLevelClick = (e: Event) => {
    //e.stopImmediatePropagation()
    e.stopPropagation()
    //e.preventDefault()
    if (dialogParts.emptySpaceClickHandlerFn) {
      dialogParts.emptySpaceClickHandlerFn(e)
    }
  }
  ;(<SYSDialogBase>dialogComp).dialogHolderParams = {
    dialogParts: dialogParts,
    dialogType: dialogComp.dialog,
    instance: dialogParts.instance,
  }
  let handleDismiss = (e: Event) => {
    e.stopPropagation()
    e.preventDefault()
    if (dialogParts.closeOnDismiss) {
      DialogClose(dialogComp.dialog, { instance: dialogParts.instance })
    } else if (dialogParts.dismissedCallbackFn) {
      dialogParts.dismissedCallbackFn()
    }
  }
  let keyHandler = defaultKeyHandler
  if (dialogParts.keyHandlerFn) {
    keyHandler = dialogParts.keyHandlerFn
  }

  let fullheader

  let dtitle
  if (dialogParts.title) {
    dtitle = await dialogParts.title()
  }
  let dheader
  if (dialogParts.header) {
    dheader = await dialogParts.header()
  }

  if (dheader || dtitle) {
    let title
    if (dtitle) {
      title = html`
        <div class="fd-bar__element">
          <h4 class="fd-message-box__title">${dtitle}</h4>
        </div>
      `
    }
    let header
    if (dheader) {
      title = html` <div class="fd-bar__element">${dheader}</div> `
    }
    let iconname: string
    if (dialogParts.type) {
      iconname = `message-${dialogParts.type()}`
      switch (dialogParts.type()) {
        case "confirmation":
          iconname = "question-mark"
      }
    }
    let icon
    if (iconname) {
      icon = html`<i class=${`sap-icon--${iconname}`}></i>`
    }

    fullheader = html`
      <header class="fd-bar fd-message-box__header ovl-dialog-header">
        <div class="fd-bar__left">${icon}${header} ${title}</div>
      </header>
    `
  }
  let body

  let dbody = await dialogParts.body()

  if (dbody) {
    body = html`<div class="fd-message-box__body ovl-dialog-body">
      ${dbody}
    </div>`
  }

  let footer
  let dfooter = await dialogParts.footer()
  if (dfooter) {
    footer = html`<footer
      class="fd-message-box__footer fd-bar fd-bar--footer ovl-dialog-footer"
    >
      <div class="fd-bar__right">${dfooter}</div>
    </footer>`
  }
  let customClass = ""
  if (dialogParts.customClass) {
    customClass = dialogParts.customClass()
  }
  let typeClass = ""
  if (dialogParts.type) {
    typeClass = "fd-message-box--" + dialogParts.type
  }

  typeClass = `${typeClass} ovl_dlg_z_index_${dialogComp.zIndex}`

  return html`<div
    class=${`fd-message-box ${typeClass}  fd-message-box--active fadeInDialog`}
    @mousedown=${(e) => {
      if (e.which === 1) handleDismiss(e)
    }}
  >
    <section
      class=${`fd-message-box__content ovl-dialog ovl-dialog-${dialogComp.dialog} ${customClass}`}
      role="dialog"
      tabindex="-1"
      aria-modal="true"
      @mousedown=${(e) => {
        if (e.which === 1) {
          e.stopPropagation()
        }
      }}
      @click=${handleTopLevelClick}
      @keyup=${keyHandler}
      id=${`ovl-dialog-${dialogComp.dialog}-${dialogParts.instance}`}
    >
      ${fullheader} ${body} ${footer}
    </section>
  </div>`
}
